// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Orbitron:wght@600;800;900&family=Poppins:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
  --fp-orange    : #ff6a00;
  --fp-orange2   : #ff9533;
  --fp-orange-gl : rgba(255, 106, 0, 0.28);
  --fp-blue      : #0047cc;
  --fp-blue2     : #002b88;
  --fp-white     : #ffffff;
  --fp-bg        : #f0f4ff;
  --fp-border    : #dde4f7;
  --fp-text      : #0d1b3e;
  --fp-muted     : #6b7280;
  --fp-err       : #ef4444;
  --fp-r         : 14px;
}

/* ══ ROOT ══ */
.zuppa_lms_forgot_pg_root {
  position        : relative;
  display         : flex;
  align-items     : center;
  justify-content : center;
  width           : 100%;
  background      : linear-gradient(135deg, #e8eeff 0%, #f0f4ff 50%, #ffe8d6 100%);
  font-family     : 'Poppins', sans-serif;
  overflow        : hidden;
  padding         : 40px 16px;
  box-sizing      : border-box;
  animation       : fp_root_in 0.4s ease both;
}
@keyframes fp_root_in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* ── Animated background orbs ── */
.zuppa_lms_forgot_pg_orb {
  position      : absolute;
  border-radius : 50%;
  pointer-events: none;
  filter        : blur(60px);
}
.zuppa_lms_forgot_pg_orb_1 {
  width      : 420px;
  height     : 420px;
  top        : -120px;
  left       : -120px;
  background : rgba(0, 71, 204, 0.12);
  animation  : fp_orb 8s ease-in-out infinite;
}
.zuppa_lms_forgot_pg_orb_2 {
  width      : 320px;
  height     : 320px;
  bottom     : -80px;
  right      : -80px;
  background : rgba(255, 106, 0, 0.12);
  animation  : fp_orb 10s ease-in-out 2s infinite;
}
.zuppa_lms_forgot_pg_orb_3 {
  width      : 200px;
  height     : 200px;
  top        : 50%;
  left       : 60%;
  background : rgba(0, 71, 204, 0.07);
  animation  : fp_orb 7s ease-in-out 1s infinite;
}
@keyframes fp_orb {
  0%,100% { transform: scale(1)    translate(0, 0); }
  50%     { transform: scale(1.15) translate(20px, -20px); }
}

/* ══ CARD ══ */
.zuppa_lms_forgot_pg_card {
  position        : relative;
  width           : 100%;
  max-width       : 460px;
  background      : var(--fp-white);
  border-radius   : 24px;
  padding         : 44px 40px 36px;
  box-shadow      : 0 20px 60px rgba(0, 71, 204, 0.12),
                    0 4px 20px rgba(0, 0, 0, 0.06);
  display         : flex;
  flex-direction  : column;
  align-items     : center;
  gap             : 16px;
  /* Card slides up on load */
  animation       : fp_card_in 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
  z-index         : 2;
}
@keyframes fp_card_in {
  from { opacity: 0; transform: translateY(50px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0)    scale(1);    }
}

/* Top orange accent bar */
.zuppa_lms_forgot_pg_accent_bar {
  position      : absolute;
  top           : 0;
  left          : 0;
  right         : 0;
  height        : 4px;
  border-radius : 24px 24px 0 0;
  background    : linear-gradient(90deg, var(--fp-blue) 0%, var(--fp-orange) 100%);
}

/* Logo */
.zuppa_lms_forgot_pg_logo {
  width      : 72px;
  height     : auto;
  object-fit : contain;
  filter     : drop-shadow(0 4px 12px rgba(255,106,0,0.2));
  animation  : fp_logo_pop 0.6s cubic-bezier(0.22,1,0.36,1) 0.5s both;
}
@keyframes fp_logo_pop {
  from { opacity: 0; transform: scale(0.7); }
  to   { opacity: 1; transform: scale(1);   }
}

/* Shield icon */
.zuppa_lms_forgot_pg_shield_wrap {
  display         : flex;
  align-items     : center;
  justify-content : center;
  width           : 80px;
  height          : 80px;
  border-radius   : 50%;
  background      : linear-gradient(135deg, rgba(0,71,204,0.08), rgba(255,106,0,0.08));
  border          : 2px solid rgba(0, 71, 204, 0.12);
  animation       : fp_shield_spin 0.8s cubic-bezier(0.22,1,0.36,1) 0.6s both;
}
@keyframes fp_shield_spin {
  from { opacity: 0; transform: rotate(-20deg) scale(0.7); }
  to   { opacity: 1; transform: rotate(0deg)   scale(1);   }
}

/* Title */
.zuppa_lms_forgot_pg_title {
  font-family    : 'Orbitron', sans-serif;
  font-size      : clamp(1.2rem, 3vw, 1.55rem);
  font-weight    : 800;
  color          : var(--fp-blue);
  margin         : 0;
  text-align     : center;
  letter-spacing : 0.02em;
}

/* Sub text */
.zuppa_lms_forgot_pg_sub {
  font-size   : 0.83rem;
  color       : var(--fp-muted);
  text-align  : center;
  line-height : 1.65;
  margin      : -6px 0 2px;
  max-width   : 340px;
}

/* ── Form ── */
.zuppa_lms_forgot_pg_form {
  width          : 100%;
  display        : flex;
  flex-direction : column;
  gap            : 6px;
}

/* Field */
.zuppa_lms_forgot_pg_field {
  width          : 100%;
  display        : flex;
  flex-direction : column;
  gap            : 6px;
}

/* Label */
.zuppa_lms_forgot_pg_label {
  font-size   : 0.8rem;
  font-weight : 600;
  color       : var(--fp-text);
  padding-left: 2px;
}

/* Input wrap */
.zuppa_lms_forgot_pg_input_wrap {
  position    : relative;
  width       : 100%;
  display     : flex;
  align-items : center;
}

/* Input icon */
.zuppa_lms_forgot_pg_input_icon {
  position        : absolute;
  left            : 14px;
  top             : 40%;
  transform       : translateY(-50%);
  display         : flex;
  align-items     : center;
  justify-content : center;
  pointer-events  : none;
  z-index         : 2;
}

/* Input */
.zuppa_lms_forgot_pg_input {
  width         : 100%;
  padding       : 14px 16px 14px 46px;
  border        : 1.8px solid var(--fp-border);
  border-radius : var(--fp-r);
  font-size     : 0.9rem;
  font-family   : 'Poppins', sans-serif;
  color         : var(--fp-text);
  background    : #f7f9ff;
  outline       : none;
  box-sizing    : border-box;
  transition    : border-color 0.25s, box-shadow 0.25s, background 0.25s;
}
.zuppa_lms_forgot_pg_input::placeholder { color: #aab4cc; }
.zuppa_lms_forgot_pg_input:focus {
  border-color : var(--fp-orange);
  background   : #fff;
  box-shadow   : 0 0 0 3.5px rgba(255,106,0,0.13);
}
.zuppa_lms_forgot_pg_input_bad {
  border-color : var(--fp-err) !important;
  box-shadow   : 0 0 0 3px rgba(239,68,68,0.1) !important;
}

/* Error msg */
.zuppa_lms_forgot_pg_err {
  font-size    : 0.72rem;
  color        : var(--fp-err);
  padding-left : 4px;
  margin       : 0;
}

/* Submit button */
.zuppa_lms_forgot_pg_btn {
  width           : 100%;
  padding         : 14px;
  margin-top      : 8px;
  border          : none;
  border-radius   : var(--fp-r);
  background      : linear-gradient(120deg, var(--fp-orange) 0%, var(--fp-orange2) 100%);
  color           : #fff;
  font-family     : 'Orbitron', sans-serif;
  font-size       : 0.9rem;
  font-weight     : 700;
  letter-spacing  : 0.08em;
  cursor          : pointer;
  display         : flex;
  align-items     : center;
  justify-content : center;
  gap             : 10px;
  box-shadow      : 0 7px 22px var(--fp-orange-gl);
  transition      : transform 0.2s, box-shadow 0.2s, filter 0.2s;
}
.zuppa_lms_forgot_pg_btn:hover {
  transform  : translateY(-2px);
  box-shadow : 0 12px 32px var(--fp-orange-gl);
  filter     : brightness(1.07);
}
.zuppa_lms_forgot_pg_btn:active { transform: translateY(0); }

/* ── Success State ── */
.zuppa_lms_forgot_pg_success {
  display        : flex;
  flex-direction : column;
  align-items    : center;
  gap            : 12px;
  animation      : fp_card_in 0.5s ease both;
}

.zuppa_lms_forgot_pg_success_icon {
  width           : 64px;
  height          : 64px;
  border-radius   : 50%;
  background      : linear-gradient(135deg, var(--fp-blue), var(--fp-orange));
  color           : white;
  font-size       : 1.8rem;
  font-weight     : 700;
  display         : flex;
  align-items     : center;
  justify-content : center;
  box-shadow      : 0 8px 24px var(--fp-orange-gl);
  animation       : fp_check_pop 0.5s cubic-bezier(0.22,1,0.36,1) both;
}
@keyframes fp_check_pop {
  from { transform: scale(0); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}

/* Back to login button */
.zuppa_lms_forgot_pg_back_btn {
  display         : flex;
  align-items     : center;
  justify-content : center;
  gap             : 6px;
  background      : none;
  border          : none;
  cursor          : pointer;
  font-family     : 'Poppins', sans-serif;
  font-size       : 0.82rem;
  font-weight     : 600;
  color           : var(--fp-blue);
  text-decoration : underline;
  margin-top      : 4px;
  padding         : 4px 0;
  transition      : color 0.2s, transform 0.2s;
}
.zuppa_lms_forgot_pg_back_btn:hover {
  color     : var(--fp-orange);
  transform : translateX(-3px);
}

/* ════════════════════════════════════
   RESPONSIVE — Tablet ≤ 600px
════════════════════════════════════ */
@media (max-width: 600px) {
  .zuppa_lms_forgot_pg_root {
    padding   : 24px 14px;
    align-items: flex-start;
    padding-top: 40px;
  }
  .zuppa_lms_forgot_pg_card {
    padding       : 36px 22px 28px;
    border-radius : 20px;
  }
  .zuppa_lms_forgot_pg_logo        { width: 60px; }
  .zuppa_lms_forgot_pg_shield_wrap { width: 66px; height: 66px; }
  .zuppa_lms_forgot_pg_title       { font-size: 1.15rem; }
  .zuppa_lms_forgot_pg_sub         { font-size: 0.8rem; }
  .zuppa_lms_forgot_pg_btn         { font-size: 0.83rem; padding: 13px; }
}

/* ════════════════════════════════════
   RESPONSIVE — Small phone ≤ 380px
════════════════════════════════════ */
@media (max-width: 380px) {
  .zuppa_lms_forgot_pg_card    { padding: 28px 16px 22px; }
  .zuppa_lms_forgot_pg_title   { font-size: 1rem; }
  .zuppa_lms_forgot_pg_logo    { width: 52px; }
  .zuppa_lms_forgot_pg_btn     { font-size: 0.8rem; padding: 12px; }
  .zuppa_lms_forgot_pg_input   { font-size: 0.85rem; }
}`, "",{"version":3,"sources":["webpack://./src/Auth/ForgotPassword.css"],"names":[],"mappings":";AAGA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wCAAwC;EACxC,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,gFAAgF;EAChF,uCAAuC;EACvC,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,2CAA2C;AAC7C;AACA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,mCAAmC;AACnC;EACE,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,8CAA8C;AAChD;AACA;EACE,UAAU,sCAAsC,EAAE;EAClD,UAAU,6CAA6C,EAAE;AAC3D;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;EACtB,gCAAgC;EAChC;kDACgD;EAChD,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;EAC3B,0EAA0E;EAC1E,mBAAmB;AACrB;AACA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,oCAAoC,KAAK;AAC9D;;AAEA,0BAA0B;AAC1B;EACE,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,gFAAgF;AAClF;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,wDAAwD;EACxD,mEAAmE;AACrE;AACA;EACE,OAAO,UAAU,EAAE,qBAAqB,EAAE;EAC1C,OAAO,UAAU,EAAE,mBAAmB,IAAI;AAC5C;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,oFAAoF;EACpF,kDAAkD;EAClD,2EAA2E;AAC7E;AACA;EACE,OAAO,UAAU,EAAE,oCAAoC,EAAE;EACzD,OAAO,UAAU,EAAE,kCAAkC,IAAI;AAC3D;;AAEA,UAAU;AACV;EACE,uCAAuC;EACvC,4CAA4C;EAC5C,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;EACrB,kCAAkC;EAClC,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mCAAmC;EACnC,4CAA4C;EAC5C,2BAA2B;EAC3B,sBAAsB;EACtB,qCAAqC;EACrC,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,sEAAsE;AACxE;AACA,0CAA0C,cAAc,EAAE;AAC1D;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,uCAAuC;EACvC,uDAAuD;AACzD;;AAEA,cAAc;AACd;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,sFAAsF;EACtF,sBAAsB;EACtB,wCAAwC;EACxC,wBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,gDAAgD;EAChD,8DAA8D;AAChE;AACA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,6BAA6B;AAC/B;AACA,kCAAkC,wBAAwB,EAAE;;AAE5D,wBAAwB;AACxB;EACE,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,2EAA2E;EAC3E,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,gDAAgD;EAChD,oEAAoE;AACtE;AACA;EACE,OAAO,mBAAmB,EAAE,UAAU,EAAE;EACxC,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,uCAAuC;EACvC,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;EACvB,4CAA4C;AAC9C;AACA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;;sCAEsC;AACtC;EACE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;EACA,mCAAmC,WAAW,EAAE;EAChD,mCAAmC,WAAW,EAAE,YAAY,EAAE;EAC9D,mCAAmC,kBAAkB,EAAE;EACvD,mCAAmC,iBAAiB,EAAE;EACtD,mCAAmC,kBAAkB,EAAE,aAAa,EAAE;AACxE;;AAEA;;sCAEsC;AACtC;EACE,+BAA+B,uBAAuB,EAAE;EACxD,+BAA+B,eAAe,EAAE;EAChD,+BAA+B,WAAW,EAAE;EAC5C,+BAA+B,iBAAiB,EAAE,aAAa,EAAE;EACjE,+BAA+B,kBAAkB,EAAE;AACrD","sourcesContent":["\r\n@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@600;800;900&family=Poppins:wght@300;400;500;600&display=swap');\r\n\r\n:root {\r\n  --fp-orange    : #ff6a00;\r\n  --fp-orange2   : #ff9533;\r\n  --fp-orange-gl : rgba(255, 106, 0, 0.28);\r\n  --fp-blue      : #0047cc;\r\n  --fp-blue2     : #002b88;\r\n  --fp-white     : #ffffff;\r\n  --fp-bg        : #f0f4ff;\r\n  --fp-border    : #dde4f7;\r\n  --fp-text      : #0d1b3e;\r\n  --fp-muted     : #6b7280;\r\n  --fp-err       : #ef4444;\r\n  --fp-r         : 14px;\r\n}\r\n\r\n/* ══ ROOT ══ */\r\n.zuppa_lms_forgot_pg_root {\r\n  position        : relative;\r\n  display         : flex;\r\n  align-items     : center;\r\n  justify-content : center;\r\n  width           : 100%;\r\n  background      : linear-gradient(135deg, #e8eeff 0%, #f0f4ff 50%, #ffe8d6 100%);\r\n  font-family     : 'Poppins', sans-serif;\r\n  overflow        : hidden;\r\n  padding         : 40px 16px;\r\n  box-sizing      : border-box;\r\n  animation       : fp_root_in 0.4s ease both;\r\n}\r\n@keyframes fp_root_in {\r\n  from { opacity: 0; }\r\n  to   { opacity: 1; }\r\n}\r\n\r\n/* ── Animated background orbs ── */\r\n.zuppa_lms_forgot_pg_orb {\r\n  position      : absolute;\r\n  border-radius : 50%;\r\n  pointer-events: none;\r\n  filter        : blur(60px);\r\n}\r\n.zuppa_lms_forgot_pg_orb_1 {\r\n  width      : 420px;\r\n  height     : 420px;\r\n  top        : -120px;\r\n  left       : -120px;\r\n  background : rgba(0, 71, 204, 0.12);\r\n  animation  : fp_orb 8s ease-in-out infinite;\r\n}\r\n.zuppa_lms_forgot_pg_orb_2 {\r\n  width      : 320px;\r\n  height     : 320px;\r\n  bottom     : -80px;\r\n  right      : -80px;\r\n  background : rgba(255, 106, 0, 0.12);\r\n  animation  : fp_orb 10s ease-in-out 2s infinite;\r\n}\r\n.zuppa_lms_forgot_pg_orb_3 {\r\n  width      : 200px;\r\n  height     : 200px;\r\n  top        : 50%;\r\n  left       : 60%;\r\n  background : rgba(0, 71, 204, 0.07);\r\n  animation  : fp_orb 7s ease-in-out 1s infinite;\r\n}\r\n@keyframes fp_orb {\r\n  0%,100% { transform: scale(1)    translate(0, 0); }\r\n  50%     { transform: scale(1.15) translate(20px, -20px); }\r\n}\r\n\r\n/* ══ CARD ══ */\r\n.zuppa_lms_forgot_pg_card {\r\n  position        : relative;\r\n  width           : 100%;\r\n  max-width       : 460px;\r\n  background      : var(--fp-white);\r\n  border-radius   : 24px;\r\n  padding         : 44px 40px 36px;\r\n  box-shadow      : 0 20px 60px rgba(0, 71, 204, 0.12),\r\n                    0 4px 20px rgba(0, 0, 0, 0.06);\r\n  display         : flex;\r\n  flex-direction  : column;\r\n  align-items     : center;\r\n  gap             : 16px;\r\n  /* Card slides up on load */\r\n  animation       : fp_card_in 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;\r\n  z-index         : 2;\r\n}\r\n@keyframes fp_card_in {\r\n  from { opacity: 0; transform: translateY(50px) scale(0.97); }\r\n  to   { opacity: 1; transform: translateY(0)    scale(1);    }\r\n}\r\n\r\n/* Top orange accent bar */\r\n.zuppa_lms_forgot_pg_accent_bar {\r\n  position      : absolute;\r\n  top           : 0;\r\n  left          : 0;\r\n  right         : 0;\r\n  height        : 4px;\r\n  border-radius : 24px 24px 0 0;\r\n  background    : linear-gradient(90deg, var(--fp-blue) 0%, var(--fp-orange) 100%);\r\n}\r\n\r\n/* Logo */\r\n.zuppa_lms_forgot_pg_logo {\r\n  width      : 72px;\r\n  height     : auto;\r\n  object-fit : contain;\r\n  filter     : drop-shadow(0 4px 12px rgba(255,106,0,0.2));\r\n  animation  : fp_logo_pop 0.6s cubic-bezier(0.22,1,0.36,1) 0.5s both;\r\n}\r\n@keyframes fp_logo_pop {\r\n  from { opacity: 0; transform: scale(0.7); }\r\n  to   { opacity: 1; transform: scale(1);   }\r\n}\r\n\r\n/* Shield icon */\r\n.zuppa_lms_forgot_pg_shield_wrap {\r\n  display         : flex;\r\n  align-items     : center;\r\n  justify-content : center;\r\n  width           : 80px;\r\n  height          : 80px;\r\n  border-radius   : 50%;\r\n  background      : linear-gradient(135deg, rgba(0,71,204,0.08), rgba(255,106,0,0.08));\r\n  border          : 2px solid rgba(0, 71, 204, 0.12);\r\n  animation       : fp_shield_spin 0.8s cubic-bezier(0.22,1,0.36,1) 0.6s both;\r\n}\r\n@keyframes fp_shield_spin {\r\n  from { opacity: 0; transform: rotate(-20deg) scale(0.7); }\r\n  to   { opacity: 1; transform: rotate(0deg)   scale(1);   }\r\n}\r\n\r\n/* Title */\r\n.zuppa_lms_forgot_pg_title {\r\n  font-family    : 'Orbitron', sans-serif;\r\n  font-size      : clamp(1.2rem, 3vw, 1.55rem);\r\n  font-weight    : 800;\r\n  color          : var(--fp-blue);\r\n  margin         : 0;\r\n  text-align     : center;\r\n  letter-spacing : 0.02em;\r\n}\r\n\r\n/* Sub text */\r\n.zuppa_lms_forgot_pg_sub {\r\n  font-size   : 0.83rem;\r\n  color       : var(--fp-muted);\r\n  text-align  : center;\r\n  line-height : 1.65;\r\n  margin      : -6px 0 2px;\r\n  max-width   : 340px;\r\n}\r\n\r\n/* ── Form ── */\r\n.zuppa_lms_forgot_pg_form {\r\n  width          : 100%;\r\n  display        : flex;\r\n  flex-direction : column;\r\n  gap            : 6px;\r\n}\r\n\r\n/* Field */\r\n.zuppa_lms_forgot_pg_field {\r\n  width          : 100%;\r\n  display        : flex;\r\n  flex-direction : column;\r\n  gap            : 6px;\r\n}\r\n\r\n/* Label */\r\n.zuppa_lms_forgot_pg_label {\r\n  font-size   : 0.8rem;\r\n  font-weight : 600;\r\n  color       : var(--fp-text);\r\n  padding-left: 2px;\r\n}\r\n\r\n/* Input wrap */\r\n.zuppa_lms_forgot_pg_input_wrap {\r\n  position    : relative;\r\n  width       : 100%;\r\n  display     : flex;\r\n  align-items : center;\r\n}\r\n\r\n/* Input icon */\r\n.zuppa_lms_forgot_pg_input_icon {\r\n  position        : absolute;\r\n  left            : 14px;\r\n  top             : 40%;\r\n  transform       : translateY(-50%);\r\n  display         : flex;\r\n  align-items     : center;\r\n  justify-content : center;\r\n  pointer-events  : none;\r\n  z-index         : 2;\r\n}\r\n\r\n/* Input */\r\n.zuppa_lms_forgot_pg_input {\r\n  width         : 100%;\r\n  padding       : 14px 16px 14px 46px;\r\n  border        : 1.8px solid var(--fp-border);\r\n  border-radius : var(--fp-r);\r\n  font-size     : 0.9rem;\r\n  font-family   : 'Poppins', sans-serif;\r\n  color         : var(--fp-text);\r\n  background    : #f7f9ff;\r\n  outline       : none;\r\n  box-sizing    : border-box;\r\n  transition    : border-color 0.25s, box-shadow 0.25s, background 0.25s;\r\n}\r\n.zuppa_lms_forgot_pg_input::placeholder { color: #aab4cc; }\r\n.zuppa_lms_forgot_pg_input:focus {\r\n  border-color : var(--fp-orange);\r\n  background   : #fff;\r\n  box-shadow   : 0 0 0 3.5px rgba(255,106,0,0.13);\r\n}\r\n.zuppa_lms_forgot_pg_input_bad {\r\n  border-color : var(--fp-err) !important;\r\n  box-shadow   : 0 0 0 3px rgba(239,68,68,0.1) !important;\r\n}\r\n\r\n/* Error msg */\r\n.zuppa_lms_forgot_pg_err {\r\n  font-size    : 0.72rem;\r\n  color        : var(--fp-err);\r\n  padding-left : 4px;\r\n  margin       : 0;\r\n}\r\n\r\n/* Submit button */\r\n.zuppa_lms_forgot_pg_btn {\r\n  width           : 100%;\r\n  padding         : 14px;\r\n  margin-top      : 8px;\r\n  border          : none;\r\n  border-radius   : var(--fp-r);\r\n  background      : linear-gradient(120deg, var(--fp-orange) 0%, var(--fp-orange2) 100%);\r\n  color           : #fff;\r\n  font-family     : 'Orbitron', sans-serif;\r\n  font-size       : 0.9rem;\r\n  font-weight     : 700;\r\n  letter-spacing  : 0.08em;\r\n  cursor          : pointer;\r\n  display         : flex;\r\n  align-items     : center;\r\n  justify-content : center;\r\n  gap             : 10px;\r\n  box-shadow      : 0 7px 22px var(--fp-orange-gl);\r\n  transition      : transform 0.2s, box-shadow 0.2s, filter 0.2s;\r\n}\r\n.zuppa_lms_forgot_pg_btn:hover {\r\n  transform  : translateY(-2px);\r\n  box-shadow : 0 12px 32px var(--fp-orange-gl);\r\n  filter     : brightness(1.07);\r\n}\r\n.zuppa_lms_forgot_pg_btn:active { transform: translateY(0); }\r\n\r\n/* ── Success State ── */\r\n.zuppa_lms_forgot_pg_success {\r\n  display        : flex;\r\n  flex-direction : column;\r\n  align-items    : center;\r\n  gap            : 12px;\r\n  animation      : fp_card_in 0.5s ease both;\r\n}\r\n\r\n.zuppa_lms_forgot_pg_success_icon {\r\n  width           : 64px;\r\n  height          : 64px;\r\n  border-radius   : 50%;\r\n  background      : linear-gradient(135deg, var(--fp-blue), var(--fp-orange));\r\n  color           : white;\r\n  font-size       : 1.8rem;\r\n  font-weight     : 700;\r\n  display         : flex;\r\n  align-items     : center;\r\n  justify-content : center;\r\n  box-shadow      : 0 8px 24px var(--fp-orange-gl);\r\n  animation       : fp_check_pop 0.5s cubic-bezier(0.22,1,0.36,1) both;\r\n}\r\n@keyframes fp_check_pop {\r\n  from { transform: scale(0); opacity: 0; }\r\n  to   { transform: scale(1); opacity: 1; }\r\n}\r\n\r\n/* Back to login button */\r\n.zuppa_lms_forgot_pg_back_btn {\r\n  display         : flex;\r\n  align-items     : center;\r\n  justify-content : center;\r\n  gap             : 6px;\r\n  background      : none;\r\n  border          : none;\r\n  cursor          : pointer;\r\n  font-family     : 'Poppins', sans-serif;\r\n  font-size       : 0.82rem;\r\n  font-weight     : 600;\r\n  color           : var(--fp-blue);\r\n  text-decoration : underline;\r\n  margin-top      : 4px;\r\n  padding         : 4px 0;\r\n  transition      : color 0.2s, transform 0.2s;\r\n}\r\n.zuppa_lms_forgot_pg_back_btn:hover {\r\n  color     : var(--fp-orange);\r\n  transform : translateX(-3px);\r\n}\r\n\r\n/* ════════════════════════════════════\r\n   RESPONSIVE — Tablet ≤ 600px\r\n════════════════════════════════════ */\r\n@media (max-width: 600px) {\r\n  .zuppa_lms_forgot_pg_root {\r\n    padding   : 24px 14px;\r\n    align-items: flex-start;\r\n    padding-top: 40px;\r\n  }\r\n  .zuppa_lms_forgot_pg_card {\r\n    padding       : 36px 22px 28px;\r\n    border-radius : 20px;\r\n  }\r\n  .zuppa_lms_forgot_pg_logo        { width: 60px; }\r\n  .zuppa_lms_forgot_pg_shield_wrap { width: 66px; height: 66px; }\r\n  .zuppa_lms_forgot_pg_title       { font-size: 1.15rem; }\r\n  .zuppa_lms_forgot_pg_sub         { font-size: 0.8rem; }\r\n  .zuppa_lms_forgot_pg_btn         { font-size: 0.83rem; padding: 13px; }\r\n}\r\n\r\n/* ════════════════════════════════════\r\n   RESPONSIVE — Small phone ≤ 380px\r\n════════════════════════════════════ */\r\n@media (max-width: 380px) {\r\n  .zuppa_lms_forgot_pg_card    { padding: 28px 16px 22px; }\r\n  .zuppa_lms_forgot_pg_title   { font-size: 1rem; }\r\n  .zuppa_lms_forgot_pg_logo    { width: 52px; }\r\n  .zuppa_lms_forgot_pg_btn     { font-size: 0.8rem; padding: 12px; }\r\n  .zuppa_lms_forgot_pg_input   { font-size: 0.85rem; }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
